export default __webpack_public_path__ + "static/media/Descriptivo-Rechazos-Conectividad.ed73a4e1.pdf";